import { storeToRefs } from 'pinia';
import { useUserDetailsStore } from '@/stores/useUserDetails';
import useAcvDatadog from '@/composables/useAcvDatadog';

export function useMixpanelTrack(event, properties) {
  const { $mixpanel } = useNuxtApp();
  const userDetailsStore = useUserDetailsStore();
  const { carrierID, userID } = storeToRefs(userDetailsStore);
  const { addRumAction } = useAcvDatadog();

  const eventProperties = {
    carrier_id: carrierID.value,
    user_id: userID.value,
    distinct_id: userID.value,
    ...properties,
  };

  $mixpanel?.track(event, eventProperties);
  addRumAction(event, eventProperties);
}
